import { omitBy, isNil } from 'lodash';
import { PurchasedVoucher, PurchasedVoucherAssignedTo } from 'src/models/telemed-voucher';
import normalizePhoneNumber from './phone-numbers';

const model = (data: { orderID: string, assignedTo: PurchasedVoucherAssignedTo, vouchers: PurchasedVoucher[]}) => {
  return omitBy({
    orderID: data.orderID,
    vouchers: data.vouchers.map(v => v.code),
    assignedTo: omitBy({
      fullName: data.assignedTo.fullName,
      email: data.assignedTo.email,
      contactNumber: data.assignedTo.contactNumber ? normalizePhoneNumber({ ...data.assignedTo.contactNumber, type: 'MOBILE' }) : undefined,
    }, isNil),
  }, isNil)
}

export default model;
